module.exports = __webpack_public_path__ + "img/kongs.b08f4e7e.png";